// extracted by mini-css-extract-plugin
export default {"market":"style_market__WA7PR","header":"style_header__jZgTO","body":"style_body__9DuEJ","bets":"style_bets__-IuMm","bet":"style_bet__wjnzw","racers":"style_racers__cMzF+"};